<template>
  <div>
    <div class="fullView">
      <div v-if="!this.$store.state.isLogin" class="none-user-container">
        <MainHeader class="header" />
      </div>

      <div v-else class="exist-user-container">
        <MyHeader class="header" />
      </div>

      <!-- <MainMenu class="menu"/> -->
      <re-main-menu class="menu" />
      <MobileMenu
        ref="mobileMenuRef"
        class="mobileMenu"
        @menuOpenCheck="openMobileMenuCheckRequest"
      />

      <router-view
        id="view"
        class="view"
        :style="{ position: positionCheck, overflow: overflowCheck }"
      />

      <!-- <main-popup-first :dialogFormVisible.sync = "openFirst" ></main-popup-first> -->
    </div>
  </div>
</template>

<script>
import MainHeader from "@/pages/basic/mainHeader.vue";
import ReMainMenu from "@/pages/basic/reMainMenu.vue";
import MyHeader from "../pages/myHeader.vue";
import MobileMenu from "@/pages/basic/mobileMenu.vue";
// import MainPopupFirst from '@/pages/myPage/mainPopup/mainPopupFirst.vue'

export default {
  data() {
    return {
      checkMobile: false,
      positionCheck: "absolute",
      overflowCheck: "hidden",
      openFirst: true,
      startEvent: false,

      openMobileMenuCheck: false,
    };
  },
  components: {
    MainHeader,
    // MainMenu,
    ReMainMenu,
    MyHeader,
    MobileMenu,
    // MainPopupFirst,
  },
  methods: {
    isMobile() {
      var user = navigator.userAgent;

      // console.log(user)

      if (
        user.indexOf("iPhone") > -1 ||
        user.indexOf("Android") > -1 ||
        user.indexOf("iPad") > -1 ||
        user.indexOf("iPod") > -1
      ) {
        this.checkMobile = true;
      }
    },
    mobileStyle() {
      // console.log("checkMobile: " + this.checkMobile);

      if (this.checkMobile) {
        this.positionCheck = "inherit";
      }

      this.touchEventCheck();
    },
    openPopup() {
      this.$cookies.set("popupCheck", false, { path: "parking2.gmuc.co.kr" });

      console.log("popupOpenCookieFirst: " + this.$cookies.get("popupCheck"));

      if (this.$cookies.get("popupCheck") == false) {
        // open window
        window.open(
          "/popup/gmuc",
          "_blank",
          "width=500px, height=600px, top=50, left=50, scrollbars= 0, toolbar=0, menubar=no"
        );
        // cookies reset
        this.$cookies.set("popupCheck", true);
      }

      console.log("open");

      // this.$store.state.popupCheck = true;

      console.log("popupOpenCookieFinalCheck: " + this.$cookies.get("popupCheck"));
    },
    // 모바일 메뉴 열림 여부 판단
    openMobileMenuCheckRequest(data) {
      this.openMobileMenuCheck = data;

      // console.log("모바일메뉴 확인", this.openMobileMenuCheck);
    },

    touchEventCheck() {
      // console.log('함수 호출여부 확인');
      const routerViewArea = document.getElementById("view");

      if (!routerViewArea) {
        return;
      }

      document.addEventListener(
        "touchstart",
        (e) => {
          e.preventDefault();

          // this.startEvent = true;
        },
        { passive: false }
      );

      document.addEventListener(
        "touchmove",
        (e) => {
          e.preventDefault();
        },
        { passive: false }
      );

      const locationPathName = window.location.pathname;

      // console.log('locationPathName', locationPathName);

      // console.log("모바일 열림 확인", this.openMobileMenuCheck);

      routerViewArea.addEventListener("click", () => {
        if (locationPathName != "/login") {
          if (this.openMobileMenuCheck == true) {
            this.$refs.mobileMenuRef.menuOutAreaTouchCloseMenuInfo();
          } else {
            return;
          }
        } else {
          return;
        }
      });

      routerViewArea.addEventListener("touchend", () => {
        if (locationPathName != "/login") {
          if (this.openMobileMenuCheck == true) {
            this.$refs.mobileMenuRef.menuOutAreaTouchCloseMenuInfo();
          } else {
            return;
          }
        } else {
          return;
        }
      });
    },
  },
  mounted() {
    this.isMobile();

    this.mobileStyle();

    // this.openPopup();
  },
  updated() {
    this.touchEventCheck();
  },
};
</script>

<style scoped>
@import "@/assets/css/reset.css";

/* Menu display */
.mobileMenu {
  display: none;
}

.fillView {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

div {
  /* width: 100%; */
  height: auto;
  margin: 0;
}
.header {
  z-index: 1200;
  position: relative;
  width: 100%;
}
.menu {
  width: 100%;
  align-items: center;
  z-index: 3;
  position: sticky;
  top: 0;
  background-color: transparent;
}

.view {
  height: auto;
  align-items: center;
  position: absolute;
  top: 0;
  overflow: hidden;
  margin-top: 185px;
  width: 100%;
}

/* 반응형 웹 CSS */
@media all and (max-width: 1200px) {
  .view {
    width: 100vw;
    margin-top: 25vh;
  }
}

/* 모바일 반응형 css 시작 */
@media all and (max-width: 960px) {
  /* Menu display */
  .menu {
    display: none;
  }

  .mobileMenu {
    display: block;
    z-index: 100 !important;
  }

  .header {
    display: none;
  }

  .mobileMenu {
    width: 100%;
    align-items: center;
    z-index: 3;
    position: fixed;
    margin-top: 1vh;
    top: 0;
    background-color: transparent;
  }

  .view {
    margin-top: 11vh;
  }
}

/* 높이 반응형 */
@media all and (max-height: 600px) {
  .view {
    margin-top: 10vh;
  }
}
</style>
